module.exports = __webpack_public_path__ + "static/media/kaIcon.b7d05c3e.svg";